export default "__VITE_ASSET__BrAOxLAz__"